import { BaseModel, WithoutBaseProps } from './BaseModel';

export type PlanPeriod = 'monthly' | 'yearly';
export type PlanLimitationType = 'commits';
export type PlanStatus = 'active' | 'archived';
export type PlanVisibility = 'public' | 'private';

export interface PlanFeature {
	id: string;
	listIndex: number;
	label: string;
}

export interface PlanLimitation {
	type: PlanLimitationType;
	maxValue: number;
	unlimited: boolean;
}

export interface Plan extends BaseModel {
	name: string;
	description: string;

	status: PlanStatus;
	visibility: PlanVisibility;

	price: Record<PlanPeriod, number>;
	priceId: Record<PlanPeriod, string>;
	productId: string;

	limitations: Record<PlanLimitationType, PlanLimitation>;
	features?: Record<string, PlanFeature>;

	archivedAt?: string;
}

export interface PlanMutation extends Omit<
	WithoutBaseProps<Plan>,
	'priceId' | 'productId'
> {}

export interface Period {
	id: PlanPeriod;
	label: string;
	tag: string;
}

// Vars, mocks, defaults
export const periods: Record<PlanPeriod, Period> = {
	monthly: {
		id: 'monthly',
		label: 'Mensal',
		tag: 'mês',
	},
	yearly: {
		id: 'yearly',
		label: 'Anual',
		tag: 'ano',
	},
};

export const periodsMap: Record<PlanPeriod, string> = {
	monthly: 'Mensal',
	yearly: 'Anual',
};

export const planLimitationTypeMap: Record<PlanLimitationType, string> = {
	commits: 'Commits',
};

export const planStatusMap: Record<PlanStatus, string> = {
	active: 'Ativo',
	archived: 'Arquivado',
};

export const planVisibilityMap: Record<PlanVisibility, string> = {
	public: 'Público',
	private: 'Privado',
};
